// Carry Roll OfflineStatus — PWA/offline indicator + SW state (11.2).

import { useEffect, useState } from 'react';

const SW_LABELS: Record<string, string> = {
  unsupported: 'not available in this browser',
  registering: 'enabling offline access…',
  active: 'ready for offline use',
  none: 'will activate once installed',
  error: 'failed to load',
};

export function OfflineStatus() {
  const [online, setOnline] = useState(true);
  const [swState, setSwState] = useState<string>('unsupported');

  useEffect(() => {
    const updateOnline = () => setOnline(navigator.onLine);
    updateOnline();
    window.addEventListener('online', updateOnline);
    window.addEventListener('offline', updateOnline);

    if ('serviceWorker' in navigator) {
      setSwState('registering');
      navigator.serviceWorker
        .getRegistration()
        .then((reg) => {
          setSwState(reg ? 'active' : 'none');
        })
        .catch(() => setSwState('error'));
    }

    return () => {
      window.removeEventListener('online', updateOnline);
      window.removeEventListener('offline', updateOnline);
    };
  }, []);

  return (
    <div data-testid="offline-status" className="flex items-center gap-3">
      <span
        className="badge"
        style={{ borderColor: online ? 'var(--color-success)' : 'var(--color-warn)' }}
        aria-label={online ? 'Online' : 'Offline — app fully functional'}
      >
        {online ? '● Online' : '● Offline-ready'}
      </span>
      <span className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
        Offline support: {SW_LABELS[swState] ?? swState}
      </span>
    </div>
  );
}
